import { type ReactNode, useId } from 'react'
import clsx from 'clsx'
import * as RadixSwitch from '@radix-ui/react-switch'
import { switchStyles, switchWithLabel, thumbStyles } from './Switch.css'

export type SwitchProps = RadixSwitch.SwitchProps

export const Switch = ({ className, ...props }: SwitchProps) => {
  return (
    <RadixSwitch.Root className={clsx(switchStyles, className)} {...props}>
      <RadixSwitch.Thumb className={thumbStyles} />
    </RadixSwitch.Root>
  )
}

export type SwitchWithLabelProps = SwitchProps & { label: ReactNode }

export const SwitchWithLabel = ({ id, label, ...forwardedProps }: SwitchWithLabelProps) => {
  const autoId = useId()
  const switchId = id ?? autoId
  return (
    <div className={switchWithLabel}>
      <label htmlFor={switchId}>{label}</label>
      <Switch id={switchId} {...forwardedProps} />
    </div>
  )
}
